/* angular:styles/component:css;18a320a45f4f85942fcf1118ad2c183aebd5ac7a5f15f63fc9aec92702345e5e;/src/src/app/edge/live/Controller/Heat/settings/settings.ts */
::ng-deep formly-form {
  height: 100% !important;
}
/*# sourceMappingURL=settings.css.map */
